import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import axios from "axios";

// Exam data
const EXAM_DATA = {
  NEET: {
    title: "NEET Mocktests",
    description:
      "Specially crafted mock papers for NEET covering Physics, Chemistry, and Biology with NCERT-based questions.",
    papers: [
      "NEET Mock Test 1",
      "NEET Mock Test 2",
      "NEET Mock Test 3",
      "NEET Mock Test 4",
      "NEET Mock Test 5",
      "NEET Answer Key",
      "NEET ANSWER KEY PAPER5"
    ],
    price: 99,
    originalPrice: 199,
    icon: "M4.5 12.75l6 6 9-13.5",
    features: [
      "Biology Focus",
      "NCERT-aligned Questions",
      "Diagrams & Illustrations",
      "Conceptual Clarity",
      "Previous Year Patterns",
    ],
    bestseller: true,
  },
  KCET: {
    title: "KCET Mocktests",
    description:
      "Mock papers for Karnataka Common Entrance Test designed by experienced faculty members.",
    papers: [
      "KCET Mock Test 1",
      "KCET Mock Test 2",
      "KCET Mock Test 3",
      "KCET Mock Test 4",
      "KCET Answer Key",
      //   "KCET Mock Test 5",
    ],
    price: 99,
    originalPrice: 199,
    icon: "M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z",
    features: [
      "Engineering Focus",
      "Karnataka-specific",
      "PCM Coverage",
      "Exam Simulation",
      "Rank Prediction",
    ],
    bestseller: false,
  }
  // UPSC: {
  //   title: "UPSC Mocktests",
  //   description:
  //     "Comprehensive mock papers for UPSC Civil Services Examination covering all subjects as per the latest pattern.",
  //   papers: [
  //     "UPSC Mock Test 1",
  //     "UPSC Mock Test 2",
  //     "UPSC Mock Test 3",
  //     "UPSC Mock Test 4",
  //     "UPSC Mock Test 5",
  //   ],
  //   price: 99,
  //   originalPrice: 199,
  //   icon: "M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z",
  //   features: [
  //     "Updated Syllabus",
  //     "In-depth Solutions",
  //     "Previous Year Analysis",
  //     "Subject-wise Feedback",
  //     "Performance Analytics",
  //   ],
  //   bestseller: true,
  // },
  // KPSC: {
  //   title: "KPSC Mocktests",
  //   description:
  //     "Well-designed mock papers for Karnataka Public Service Commission exams with detailed solutions.",
  //   papers: [
  //     "KPSC Mock Test 1",
  //     "KPSC Mock Test 2",
  //     "KPSC Mock Test 3",
  //     "KPSC Mock Test 4",
  //     "KPSC Mock Test 5",
  //   ],
  //   price: 99,
  //   originalPrice: 199,
  //   icon: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z",
  //   features: [
  //     "Karnataka-focused Content",
  //     "Bilingual Options",
  //     "Expert-designed Questions",
  //     "Comprehensive Solutions",
  //     "Time Management Tips",
  //   ],
  //   bestseller: false,
  // },
};

// Function to get Razorpay order ID
async function getRazorpayOrderId(data) {
  try {
    const response = await axios.post(
      `https://mep.scontiapp.com/samai/v1/api/v1/payment/create-order/`,
      data
    );
    console.log("get razorpay order id", response.data);
    return response.data;
  } catch (error) {
    console.error("get razorpay order id error", error);
    throw error;
  }
}

const SingleCheckoutPage = () => {
  const { cart, getTotalPrice, clearCart } = useCart();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    college: "",
    phone: "",
    email: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedExams, setSelectedExams] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [showContactPopup, setShowContactPopup] = useState(false);
  const [paymentError, setPaymentError] = useState(null);

  // Calculate total amount based on selected exams
  useEffect(() => {
    let amount = 0;
    selectedExams.forEach((examKey) => {
      amount += EXAM_DATA[examKey].price;
    });
    setTotalAmount(amount);
  }, [selectedExams]);

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^[0-9]{10}$/.test(formData.phone)) {
      newErrors.phone = "Enter a valid 10-digit phone number";
    }

    // Email is optional, but validate format if provided
    if (formData.email.trim() && !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Enter a valid email address";
    }

    if (selectedExams.length === 0) {
      newErrors.exams = "Please select at least one exam";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleExamToggle = (examKey) => {
    setSelectedExams((prevSelected) => {
      if (prevSelected.includes(examKey)) {
        return prevSelected.filter((key) => key !== examKey);
      } else {
        return [...prevSelected, examKey];
      }
    });
  };

  // Function to properly load the Razorpay script
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      // Check if Razorpay is already loaded
      if (window.Razorpay) {
        resolve(true);
        return;
      }

      // Create and load the script
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;
      script.onload = () => resolve(true);
      script.onerror = () => {
        console.error("Razorpay script failed to load");
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  // Create a direct checkout handler function
  const openRazorpayCheckout = (options) => {
    // Ensure Razorpay is available
    if (!window.Razorpay) {
      alert("Razorpay is not loaded yet. Please try again.");
      return;
    }

    try {
      // Create a new instance with the options
      const razorpayInstance = new window.Razorpay(options);

      // Set event handlers
      razorpayInstance.on("payment.failed", function (response) {
        console.error("Payment failed:", response.error);
        setPaymentError(`Payment failed: ${response.error.description}`);
        setIsSubmitting(false);
      });

      // Open the checkout
      razorpayInstance.open();
    } catch (error) {
      console.error("Error creating Razorpay instance:", error);
      setPaymentError("Could not initialize payment. Please try again.");
      setIsSubmitting(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPaymentError(null);

    if (!validate()) {
      return;
    }

    setIsSubmitting(true);

    try {
      // 1. Load Razorpay script if not already loaded
      const scriptLoaded = await loadRazorpayScript();
      if (!scriptLoaded) {
        throw new Error("Failed to load Razorpay script");
      }

      // 2. Prepare order items from selected exams
      const orderItems = selectedExams.map((examKey) => ({
        id: examKey,
        name: EXAM_DATA[examKey].title,
        price: EXAM_DATA[examKey].price,
        papers: EXAM_DATA[examKey].papers,
      }));

      // 3. Create order data for API request
      const orderRequestData = {
        amount: totalAmount * 100, // in paise
        currency: "INR",
        receipt: "receipt_" + Date.now(),
        user_id: formData.phone, // Using phone as user_id since it's required
      };

      // 4. Get Razorpay order ID from backend
      const orderData = await getRazorpayOrderId(orderRequestData);

      // 5. Configure Razorpay options
      const options = {
        key: "rzp_live_xDq8WFiHbhEEfU",
        amount: orderData.amount,
        currency: orderData.currency,
        name: "Samai Mocktests",
        description: "Purchase of Mock Test Papers",
        order_id: orderData.order_id,
        handler: async function (response) {
          try {
            console.log("Payment success:", response);
            const detailedExamData = selectedExams.map((examKey) => ({
              id: examKey,
              name: EXAM_DATA[examKey].title,
              price: EXAM_DATA[examKey].price,
              papers: EXAM_DATA[examKey].papers,
              // Include additional exam information
              description: EXAM_DATA[examKey].description,
              features: EXAM_DATA[examKey].features,
              originalPrice: EXAM_DATA[examKey].originalPrice,
              bestseller: EXAM_DATA[examKey].bestseller,
            }));
            // Save order details to Firestore
            const orderRef = await addDoc(collection(db, "orders"), {
              ...formData,
              amount: totalAmount,
              items: orderItems,
              paymentId: response.razorpay_payment_id,
              orderId: response.razorpay_order_id,
              signature: response.razorpay_signature,
              addedOn: new Date(),
            });

            // Clear cart and redirect to success page
            clearCart();
            // navigate("/success", {
            //   state: {
            //     orderId: orderRef.id,
            //     userEmail: formData.email || "Not provided",
            //     items: orderItems,
            //     totalAmount: totalAmount
            //   },
            // });
            navigate("/success", {
              state: {
                orderId: orderRef.id,
                userEmail: formData.email || "Not provided",
                userName: formData.name,
                phone: formData.phone,
                items: orderItems,
                totalAmount: totalAmount,
                // Pass detailed exam data including all test information
                examData: detailedExamData,
                // Pass raw selected exam keys for reference
                selectedExams: selectedExams,
                // Pass full EXAM_DATA in case it's needed for specific rendering
                allExamData: EXAM_DATA,
              },
            });
          } catch (error) {
            console.error("Error saving order:", error);
            alert(
              "Payment completed but order processing failed. Please contact support."
            );
          }
        },
        prefill: {
          name: formData.name,
          email: formData.email || "",
          contact: formData.phone,
        },
        notes: {
          college: formData.college || "Not provided",
        },
        theme: {
          color: "#4636FF",
        },
        modal: {
          ondismiss: function () {
            setIsSubmitting(false);
            console.log("Checkout form closed");
          },
        },
      };

      // 6. Open Razorpay checkout
      openRazorpayCheckout(options);
    } catch (error) {
      console.error("Error during checkout:", error);
      setPaymentError(
        error.message || "Something went wrong. Please try again later."
      );
      setIsSubmitting(false);
    }
  };

  return (
    <div className="py-12 bg-gray-50 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-center mb-12">Checkout</h1>

        {paymentError && (
          <div
            className="mb-6 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded relative"
            role="alert"
          >
            <strong className="font-bold">Payment Error: </strong>
            <span className="block sm:inline">{paymentError}</span>
            <button
              className="absolute top-0 bottom-0 right-0 px-4 py-3"
              onClick={() => setPaymentError(null)}
            >
              <svg
                className="h-6 w-6 text-red-500"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
        )}

        <div className="grid md:grid-cols-5 gap-8">
          <div className="md:col-span-3 bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-semibold mb-4">Personal Information</h2>
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="mb-4">
                  <label htmlFor="name" className="block text-gray-700 mb-2">
                    Full Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className={`w-full p-2 border rounded-md ${
                      errors.name ? "border-red-500" : "border-gray-300"
                    }`}
                    placeholder="Enter your full name"
                  />
                  {errors.name && (
                    <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                  )}
                </div>

                <div className="mb-4">
                  <label htmlFor="college" className="block text-gray-700 mb-2">
                    College (Optional)
                  </label>
                  <input
                    type="text"
                    id="college"
                    name="college"
                    value={formData.college}
                    onChange={handleChange}
                    className="w-full p-2 border border-gray-300 rounded-md"
                    placeholder="Enter your college name"
                  />
                </div>

                <div className="mb-4">
                  <label htmlFor="phone" className="block text-gray-700 mb-2">
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className={`w-full p-2 border rounded-md ${
                      errors.phone ? "border-red-500" : "border-gray-300"
                    }`}
                    placeholder="Enter your 10-digit phone number"
                  />
                  {errors.phone && (
                    <p className="text-red-500 text-sm mt-1">{errors.phone}</p>
                  )}
                </div>

                <div className="mb-4">
                  <label htmlFor="email" className="block text-gray-700 mb-2">
                    Email Address (Optional)
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className={`w-full p-2 border rounded-md ${
                      errors.email ? "border-red-500" : "border-gray-300"
                    }`}
                    placeholder="Enter your email address"
                  />
                  {errors.email && (
                    <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                  )}
                </div>
              </div>

              {/* Exam Selection Section */}
              <div className="mb-6 mt-4">
                <h3 className="text-lg font-semibold mb-3">Select Exams *</h3>
                <p className="text-gray-600 text-sm mb-3">
                  Choose the mock tests you want to purchase. You can select
                  multiple exams.
                </p>

                <div
                  className={`grid grid-cols-1 md:grid-cols-2 gap-3 ${
                    errors.exams ? "border border-red-500 p-3 rounded-md" : ""
                  }`}
                >
                  {Object.keys(EXAM_DATA).map((examKey) => (
                    <div
                      key={examKey}
                      className={`border p-3 rounded-md cursor-pointer transition-all duration-200 ${
                        selectedExams.includes(examKey)
                          ? "border-indigo-500 bg-indigo-50"
                          : "border-gray-300 hover:border-indigo-300"
                      }`}
                      onClick={() => handleExamToggle(examKey)}
                    >
                      <div className="flex items-start">
                        <div className="flex-shrink-0">
                          <input
                            type="checkbox"
                            checked={selectedExams.includes(examKey)}
                            onChange={() => {}} // Handled by the div click
                            className="h-4 w-4 text-indigo-600 mt-1"
                          />
                        </div>
                        <div className="ml-3">
                          <h4 className="font-medium">
                            {EXAM_DATA[examKey].title}
                          </h4>
                          <p className="text-sm text-gray-600 mt-1">
                            {EXAM_DATA[examKey].papers.length} mock tests
                          </p>
                          <div className="flex items-center mt-1">
                            <span className="font-bold text-lg">
                              ₹{EXAM_DATA[examKey].price}
                            </span>
                            {EXAM_DATA[examKey].originalPrice && (
                              <span className="ml-2 text-sm text-gray-500 line-through">
                                ₹{EXAM_DATA[examKey].originalPrice}
                              </span>
                            )}
                            {EXAM_DATA[examKey].bestseller && (
                              <span className="ml-auto bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded">
                                BESTSELLER
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {errors.exams && (
                  <p className="text-red-500 text-sm mt-1">{errors.exams}</p>
                )}
              </div>

              <div className="mt-6">
                <button
                  type="submit"
                  disabled={isSubmitting || selectedExams.length === 0}
                  className={`w-full py-3 px-4 bg-gradient-to-r from-[#4636FF] to-[#F253EC] text-white font-bold rounded-md hover:opacity-90 transition duration-300 ${
                    isSubmitting || selectedExams.length === 0
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                  }`}
                >
                  {isSubmitting ? "Processing..." : "Proceed to Payment"}
                </button>
              </div>
            </form>
          </div>

          <div className="md:col-span-2">
            <div className="bg-white p-6 rounded-lg shadow-md sticky top-24">
              <h2 className="text-xl font-semibold mb-4">Order Summary</h2>

              {selectedExams.length === 0 ? (
                <p className="text-center text-gray-500 my-4">
                  No exams selected yet
                </p>
              ) : (
                <>
                  <div className="mb-4">
                    {selectedExams.map((examKey) => (
                      <div
                        key={examKey}
                        className="flex justify-between py-2 border-b"
                      >
                        <span>{EXAM_DATA[examKey].title}</span>
                        <span>₹{EXAM_DATA[examKey].price}</span>
                      </div>
                    ))}
                  </div>

                  <div className="flex justify-between font-bold text-lg pt-2">
                    <span>Total:</span>
                    <span>₹{totalAmount}</span>
                  </div>

                  {/* Order summary details */}
                  <div className="mt-4 pt-4 border-t">
                    <h3 className="font-medium text-gray-700 mb-2">
                      What you'll get:
                    </h3>
                    <ul className="text-sm text-gray-600 space-y-1">
                      {selectedExams.map((examKey) => (
                        <li key={`detail-${examKey}`}>
                          • {EXAM_DATA[examKey].papers.length}{" "}
                          {EXAM_DATA[examKey].title} with solutions
                        </li>
                      ))}
                      <li>• Instant access to all mock tests</li>
                      <li>• Detailed performance analytics</li>
                      <li>• 24/7 support access</li>
                    </ul>
                  </div>
                </>
              )}

              {/* Promotional banner */}
              <div className="mt-6 bg-blue-50 p-3 rounded-md border border-blue-100">
                <p className="text-sm text-blue-800">
                  <span className="font-bold">Special offer:</span> Select 3 or
                  more exam packages to get access to our exclusive doubt
                  clearing sessions!
                </p>
              </div>

              {/* Secure payment notice */}
              <div className="mt-4 flex items-center justify-center text-sm text-gray-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 mr-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                  />
                </svg>
                Secure payment powered by Razorpay
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Action Button for Contact */}
      <button
        onClick={() => setShowContactPopup(true)}
        className="fixed z-20 bottom-6 right-6 p-4 bg-gradient-to-r from-[#4636FF] to-[#F253EC] text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300"
        aria-label="Contact Us"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
          />
        </svg>
      </button>

      {/* Contact Popup */}
      {showContactPopup && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md mx-4 animate-fadeIn">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-gray-800">Contact Us</h3>
              <button
                onClick={() => setShowContactPopup(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <div className="space-y-4">
              <div className="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-indigo-600 mr-3"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                <div>
                  <p className="text-gray-700 font-medium">Phone Support</p>
                  <p className="text-indigo-600">+91 8050590850</p>
                </div>
              </div>

              <div className="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-indigo-600 mr-3"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                <div>
                  <p className="text-gray-700 font-medium">Email Support</p>
                  <p className="text-indigo-600">office@scontinent.com</p>
                </div>
              </div>

              <div className="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-indigo-600 mr-3"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
                  />
                </svg>
                <div>
                  <p className="text-gray-700 font-medium">WhatsApp</p>
                  <p className="text-indigo-600">+91 9876543210</p>
                </div>
              </div>
            </div>

            <div className="mt-6 pt-4 border-t border-gray-200">
              <p className="text-gray-600 text-sm">
                Our support team is available from 9 AM to 8 PM every day.
              </p>
            </div>

            <div className="mt-4 flex space-x-2">
              <a
                href="https://wa.me/918050590850"
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 bg-green-500 text-white py-2 rounded-md text-center font-medium hover:bg-green-600 transition-colors"
              >
                WhatsApp
              </a>
              <a
                href="tel:+918050590850"
                className="flex-1 bg-indigo-600 text-white py-2 rounded-md text-center font-medium hover:bg-indigo-700 transition-colors"
              >
                Call Now
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SingleCheckoutPage;
